module.exports = __webpack_public_path__ + "ee5d173e12667bff6a032cdc986149ab.svg";